var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.$d(Date.parse(_vm.date), 'zCustomMonthYear'))+" - "),_c('abbr',{attrs:{"title":"Kalenderwoche"}},[_vm._v("Kw.")]),_vm._v(" "+_vm._s(_vm.getCalendarWeekFromDate(_vm.date))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }